import React from "react";
import classes from "./DetailsTable.module.scss";

const DetailsTable = ({ required, arrayOfProps, propsData }) => {
  return (
    <table className={classes.table}>
      <thead>
        <th>Name</th>
        <th>Type</th>
        <th>Description</th>
        <th>Required</th>
      </thead>
      <tbody>
        {arrayOfProps.map((prop) => {
          if (prop === "_details") {
            if (Object.keys(prop.properties === 0)) {
              return null;
            } else {
              return (
                <DetailsTable
                  required={propsData["_details"].required}
                  arrayOfProps={Object.keys(propsData["_details"].properties)}
                  propsData={propsData["_details"].properties}
                />
              );
            }
          }
          return (
            <tr key={Math.random().toString()}>
              <td>{prop}</td>
              <td>
                {propsData[prop].$d3pro
                  ? propsData[prop].$d3pro.JSONBasicType
                  : Array.isArray(propsData[prop].type)
                  ? propsData[prop].type.join(" | ")
                  : propsData[prop].type}
              </td>
              <td>{propsData[prop].description}</td>
              <td>{required.includes(prop) ? "true" : "false"}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default DetailsTable;
